<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M12 2a10.01 10.01 0 1 0 10 10c0-5.52-4.5-10-10-10Zm6.66 10c0 .88-.17 1.74-.5 2.51l-4.48-2.6 4.44-2.56c.35.81.55 1.7.55 2.65Zm-1.41-4.08-4.42 2.55V5.4a6.64 6.64 0 0 1 4.42 2.52Zm-4.42 5.44 4.51 2.6a6.67 6.67 0 0 1-4.5 2.64v-5.24Zm-7 1.15a6.6 6.6 0 0 1 .06-5.16l4.44 2.57-4.5 2.6Zm5.34-1.15v5.24a6.67 6.67 0 0 1-4.51-2.64l4.5-2.6Zm0-2.89L6.75 7.92a6.65 6.65 0 0 1 4.42-2.52v5.07Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
